import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import MailListItemContainer from '../MailListItemContainer';
import React, { useEffect, useMemo, useState } from 'react';
import { useApplicableRichContentFlags } from 'mini-mail-list-view/lib/hooks/useApplicableRichContentFlags';

const mailListStyle = require('mini-mail-listitem-styles/lib/scss/MailListItemSkeleton.scss');
const classNames = require('classnames/bind').bind(mailListStyle);
interface MailItemWrapperProps {
    itemId: string;
    isScrolling: boolean;
    style: React.CSSProperties;
}

type SupportedClassNames =
    | 'mailItemCard'
    | 'mailItemCard-withoutRsvp'
    | 'mailItemCard-withoutPreview'
    | 'mailItemCard-withoutPreview-withoutRsvp';

const MailItemWrapper = (props: MailItemWrapperProps): JSX.Element => {
    const { itemId, isScrolling } = props;
    // Only show placeholder when user is scrolling
    const [showPlaceholder, setShowPlaceholder] = useState(isScrolling);
    const showPreviewText = getUserConfiguration().UserOptions.ShowPreviewTextInListView;

    const applicableRichContentFlags = useApplicableRichContentFlags(itemId);
    const { showRSVPUnit } = applicableRichContentFlags;

    useEffect(() => {
        // Since this doesn't block rendering like componentDidMount
        // while scrolling user will see the placeholders first and
        // in next frame actual component ie. MailListItem will render.
        setShowPlaceholder(false);
    }, []);

    const mailListItemCardClassName = useMemo(
        () => getMailListItemCardClassName(showPreviewText, showRSVPUnit),
        [showPreviewText, showRSVPUnit]
    );

    return (
        <div style={props.style} className={classNames(mailListItemCardClassName)}>
            {!showPlaceholder && (
                <MailListItemContainer
                    key={itemId}
                    rowId={itemId}
                    appliedRichContentFlags={applicableRichContentFlags}
                />
            )}
        </div>
    );
};

export default MailItemWrapper;

const getMailListItemCardClassName = (
    showPreviewText: boolean,
    showRSVPUnit: boolean
): SupportedClassNames => {
    if (showPreviewText && showRSVPUnit) {
        return 'mailItemCard';
    }
    if (showPreviewText) {
        return 'mailItemCard-withoutRsvp';
    }
    if (showRSVPUnit) {
        return 'mailItemCard-withoutPreview';
    }
    return 'mailItemCard-withoutPreview-withoutRsvp';
};
